import type { KeyPair } from '../utils/crypto';
import type { ServiceConfig } from '../types/auth';

const STORAGE_KEYS = {
  KEY_PAIR: 'userwallet_keypair',
  SERVICES: 'userwallet_services',
} as const;

export function getStoredKeyPair(): KeyPair | null {
  try {
    const stored = localStorage.getItem(STORAGE_KEYS.KEY_PAIR);
    if (stored === null) {
      return null;
    }
    return JSON.parse(stored) as KeyPair;
  } catch (error) {
    console.error('Error reading stored key pair:', error);
    return null;
  }
}

export function storeKeyPair(keyPair: KeyPair): void {
  localStorage.setItem(STORAGE_KEYS.KEY_PAIR, JSON.stringify(keyPair));
}

export function getStoredServices(): ServiceConfig[] {
  try {
    const stored = localStorage.getItem(STORAGE_KEYS.SERVICES);
    if (stored === null) {
      return [];
    }
    return JSON.parse(stored) as ServiceConfig[];
  } catch (error) {
    console.error('Error reading stored services:', error);
    return [];
  }
}

export function storeServices(services: ServiceConfig[]): void {
  localStorage.setItem(STORAGE_KEYS.SERVICES, JSON.stringify(services));
}

export function updateServiceStatus(serviceId: string, enabled: boolean): void {
  const services = getStoredServices();
  const service = services.find((s) => s.id === serviceId);
  if (service !== undefined) {
    service.enabled = enabled;
    storeServices(services);
  }
}
